module.exports = __webpack_public_path__ + "static/img/gri_980063_b24_f09_057_mm.fbb0d11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/gri_980063_b24_f09_057_mm.jpg
// module id = k42x
// module chunks = 0